import { createSelector } from 'reselect'

export const getLastChangedField = createSelector(
  state => state && state.user && state.user.list && state.user.list.lastChangedField ? state.user.list.lastChangedField : null,
  field => field
)
